import React from 'react';
import './PromoSection.css';

const PromoSection = ({ settings = {}, backgroundImageUrl }) => {
  const {
    title = 'BEST FRESH SEAFOOD MARKET ONLINE',
    subtitle = 'Everywhere, Anytime',
    buttonText = 'SHOP NOW',
    buttonLink = '/collections/all',
    textColor = '#ffffff',
    overlayOpacity = 0.6
  } = settings;

  // Используем переданный URL или дефолтный
  const imageUrl = backgroundImageUrl || 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1920&h=600&fit=crop&crop=center';

  return (
    <section className="promo-section">
      {/* Background Image */}
      <div className="promo-section__background">
        <img
          className="promo-section__image"
          src={imageUrl}
          alt={title}
          loading="lazy"
        />
        
        {/* Dark Overlay */}
        <div 
          className="promo-section__overlay"
          style={{ opacity: overlayOpacity }}
        />
      </div>

      {/* Content */}
      <div className="promo-section__container">
        <div className="promo-section__content">
          <h2 className="promo-section__title" style={{ color: textColor }}>
            {title}
          </h2>
          
          {subtitle && (
            <p className="promo-section__subtitle" style={{ color: textColor }}>
              {subtitle}
            </p>
          )}
          
          {buttonText && buttonLink && (
            <a href={buttonLink} className="promo-section__button">
              {buttonText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default PromoSection;